module.exports = require('./convert')(
  ".exportsfunc\"#$&',/:;<>?@[]^`abdghijklmqvwyz{|}~",
  "юучзщкеыагтсЭ№;?эб.ЖжБЮ,\"хъ:ёфивпршолдьймцняХ/ЪЁ"
)
